import { useState } from 'react';
import * as theme from '../../../theme';
import TruCard from '../../TruCard';
import { useNavigate } from "react-router";
import ResourceItem from '../items/ResourceItem';

export default function ResourceList({ practitionerId, isOnboarded }) {
  const navigate = useNavigate();

  return (
    <TruCard title={'Resources'}>
      {isOnboarded &&
        <ResourceItem
          icon="calendar"
          label="Schedule 1:1 Support Call"
          actionLink={() => navigate(`/practitioners/${practitionerId}/schedule-call`)}
        />
      }
      <ResourceItem
        icon="money"
        label="Billing"
        actionLink={() => navigate(`/practitioners/${practitionerId}/billing`)}
      />
      <ResourceItem
        icon="video"
        label="Additional Content"
        actionLink={() => navigate(`/practitioners/${practitionerId}/content`)}
      />
      <ResourceItem
        icon="money"
        label="Cost Structure"
        actionLink={() => navigate(`/cost-structure`)}
      />
      <ResourceItem
        icon="report"
        label="Focus Scans"
        actionLink={() => navigate(`/focus-scans`)}
      />
      <ResourceItem
        icon="report"
        label="Mini Scans"
        actionLink={() => navigate(`/mini-scans`)}
      />
    </TruCard>
  );
}